<template>
  <div>
    <v-row>
      <v-col>
        <CustomerDeliveryStatusesComponent />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <CustomerSupportTicketStatusesComponent />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CustomerDeliveryStatusesComponent from '@/components/customer/CustomerDeliveryStatusesComponent.vue';
import CustomerSupportTicketStatusesComponent from '@/components/customer/CustomerSupportTicketStatusesComponent.vue';

export default {
  name: 'CustomerWorkflow',
  components: {
    CustomerDeliveryStatusesComponent,
    CustomerSupportTicketStatusesComponent
  }
}
</script>